import { IChatbotRequest, IChatbotResponse } from 'chatbot/types';
import { postJson, TPostJsonOptions } from 'core/services';
import { LLM_BASE_URL } from 'global';

export const startChatbot = async (options: TPostJsonOptions): Promise<{ threadId: string }> =>
  postJson(`${LLM_BASE_URL}/chatbot/new`, null, options);

export const sendChatbotRequest = async (
  payload: IChatbotRequest,
  options: TPostJsonOptions
): Promise<IChatbotResponse> =>
  postJson(
    `${LLM_BASE_URL}/chatbot/message`,
    payload as unknown as Record<string, unknown>,
    options
  );
